<template>
  <div>
    <b-row class="mb-5 justify-content-end">
      <!-- Left section filtre -->
      <div class="d-flex justify-content-end  mt-2">
        <b-button class="btnFilter_2 mx-3"
                  @click="trigOnImportCSV" variant="primary">
          <i class="fa-light fa-plus "></i>
          <span class="fab-label">{{ $t('toolbox.import_testcase') }}</span>
        </b-button>
        <input
            type="file"
            ref="fileInput"
            class="d-none"
            @change="onImportCSV"
            accept=".csv"
        />
      </div>
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <hr  class="mx-auto"/>
    <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center" >
      <!--Filtre Status -->
      <b-col sm="6" lg="3" class="filter-item">
        <div>
          <span class="filter-item-title d-block mb-1">{{ $t('toolbox.filtre_status') }}</span>
          <select v-model="StatusFilter" class="filter-item-content w-100" style="padding:0.5rem;">
            <option value="" selected>----------</option>
            <option value="2">{{ $t('toolbox.filtre_status_ok') }}</option>
            <option value="0">{{ $t('toolbox.filtre_status_ko') }}</option>
            <option value="3">{{ $t('toolbox.filtre_status_missing_conf') }}</option>
            <option value="4">{{ $t('toolbox.filtre_status_pending') }}</option>
            <option value="5">{{ $t('toolbox.filtre_status_not_tested') }}</option>
          </select>
        </div>
      </b-col>
      <!--Filtre Case Summary -->
      <b-col sm="6" lg="3"  class="filter-item">
        <label class="filter-item-title">{{ $t('toolbox.filtre_case_summary') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="CaseSummary"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': CaseSummary}"
                 :placeholder="$t('toolbox.filtre_case_summary')"
                 style="width: 100%">
        </span>
      </b-col>
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
        <b-button size="sm"
                  variant="primary"
                  @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
                  @click="clearFilterFields"
                  :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-end mb-5 mr-1" v-if="displayFilter">
      <!-- Bouton Effacer et Appliquer -->

    </b-row>
    <hr  class="mx-auto mb-4" v-if="displayFilter"/>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="RequestList.length > 0" style="overflow:auto">
      <b-table hover
        class="table table-striped"
        style="margin-bottom:0"
        :fields="fields"
        :items="RequestList"
        :selectable="RequestList.length > 0"
        :per-page="paginationObject.maxResults"
        :current-page="pageCounter"
        :empty-text="$t('common.security.no_result')"
        @row-clicked="seeRequestTBDetails">

        <template #cell(response_request)="data">
          <div> {{data.item.ids_dataset.length}} </div>
        </template>

        <template #cell(case_summary)="data">
          <div> {{ $t(`toolbox.req_summary_case.${data.item.case_summary}`) }} </div>
        </template>

        <template #cell(description_case)="data">
          <div> {{ $t(`toolbox.req_description_case.${data.item.description_case}`) }} </div>
        </template>

        <template #cell(status)="data">
          <div v-if="data.value === '2'">
            <i title="OK" class="fas fa-check"
               style="color: white; background-color: green; border-radius: 50%; padding: 5px; width: 20px; height: 20px; display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
          <div v-else-if="data.value === '0'">
            <i title="KO" class="fas fa-multiply"
               style="color: white; background-color: red; border-radius: 50%; padding: 5px; width: 20px; height: 20px; display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
          <div v-else-if="data.value === '1'">
            <i title="RUN" class="fas fa-hourglass-half"
               style="color: white; background-color: orange; border-radius: 50%; padding: 5px; width: 20px; height: 20px; display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
          <div v-else-if="data.value === '3'">
            <i  title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
          </div>
          <div v-else-if="data.value === '4'">
            <i title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
          </div>
          <div v-else-if="data.value === '5'">
            <i title="Never tested" class="fas fa-minus"
               style="color: white; background-color: gray; border-radius: 50%; padding: 5px; width: 20px; height: 20px; display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
        </template>

      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'RequestTBList',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
  },
  computed: {
    fields () {
      let fields
      fields = [
        { key: 'case_summary', label: this.$i18n.t('toolbox.list_case_summary'), class: 'text-center', sortable: false },
        { key: 'description_case', label: this.$i18n.t('toolbox.list_description_case'), class: 'text-center', sortable: false },
        { key: 'response_request', label: this.$i18n.t('toolbox.list_response_request'), class: 'text-center', sortable: false },
        { key: 'status', label: this.$i18n.t('toolbox.list_status'), class: 'text-center', sortable: false },
      ]
      return fields
    },
    hasInputFilter () {
      return this.CaseSummary.length > 0 || this.StatusFilter !== '';
    },
  },
  data () {
    return {
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      statusVerification: '',
      VopProvider: '',
      Result: '',
      CaseSummary: '',
      ResultFilter: '',
      StatusFilter: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      selectionMode : 0,
      RequestList: [],
      selectedRows: []
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      let that = this
      this.RequestList = []
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.firstOn().tracking.cleanFilterCondition()

      filterConditions.CaseSummary = this.CaseSummary.trim()
      filterConditions.StatusFilter = this.StatusFilter
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex

      this.$engine.firstOn().toolbox.getTestCaseTB(
          //this.$engine.firstOn().toolbox.getAccountTB(
          filterConditions
      ).then(resp => {
        this.RequestList = []
        if (resp.data.TestCase) {
          let requests = []
          if(resp.data.TestCase.List){
            let result = []
            if(!Array.isArray(resp.data.TestCase.List))
              result.push(resp.data.TestCase.List)
            else {
              result = resp.data.TestCase.List
            }
            if (result.length > 0){
              result.forEach( test =>{
                let aux = {}
                aux.id = test["~Unknown_1"]
                if(aux.id !== "$NotFound") {
                  aux.case_summary = test["~Unknown_2"]
                  aux.description_case = test["~Unknown_3"]
                  aux.case_type = test["~Unknown_4"]
                  aux.case_type_detailed = test["~Unknown_5"]
                  aux.tested_field = test["~Unknown_6"]
                  aux.criticality = test["~Unknown_7"]
                  aux.status = test["~Unknown_8"]
                  const foundElement = requests.find(item => item.id === aux.id);
                  if (foundElement) {
                    if (aux.id_dataset.length > 0)
                      foundElement.ids_dataset.push(aux.id_dataset)
                  } else {
                    let newTestCase = {
                      id: aux.id,
                      case_summary: aux.case_summary,
                      description_case: aux.description_case,
                      case_type: aux.case_type,
                      case_type_detailed: aux.case_type_detailed,
                      tested_field: aux.tested_field,
                      criticality: aux.criticality,
                      status: aux.status,
                      ids_dataset: [],
                      ids_valid: []
                    }
                    requests.push(newTestCase)
                  }
                }
              })
            }
          }
          if(resp.data.TestCase.DatasetCount){
            let result = []
            if(!Array.isArray(resp.data.TestCase.DatasetCount))
              result.push(resp.data.TestCase.DatasetCount)
            else {
              result = resp.data.TestCase.DatasetCount
            }
            if (result.length > 0) {
              result.forEach(test => {
                let cur = {}
                cur.idTestCase = test["~Unknown_1"]
                cur.idDataset = test["~Unknown_2"]
                const foundElement = requests.find(item => item.id === cur.idTestCase);
                if (foundElement) {
                  if (cur.idDataset.length > 0)
                    foundElement.ids_dataset.push(cur.idDataset)
                }
              })
            }
          }
          if(resp.data.TestCaseValid){
            let testCaseValid = []
            if(Array.isArray(resp.data.TestCaseValid))
              testCaseValid = resp.data.TestCaseValid
            else
              testCaseValid.push(resp.data.TestCaseValid)
            testCaseValid.forEach(valid_dataset => {
              let aux = {}
              aux.idTC = valid_dataset["~Unknown_1"]
              aux.idDS = valid_dataset["~Unknown_2"]
              aux.idStatus = valid_dataset["~Unknown_3"]
              aux.lastExec = valid_dataset["~Unknown_4"]
              const foundElement = requests.find(item => item.id === aux.idTC);
              if(foundElement) {
                foundElement.ids_valid.push(aux.idDS)
              }
            })
          }
          that.paginationObject.nbResultsTotal = resp.data.TestCaseCount
          that.paginationObject.nbResults = requests.length
          that.updateInbox(requests)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.CaseSummary = ''
      this.StatusFilter = ''
      this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        CaseSummary: this.CaseSummary.trim(),
        StatusFilter: this.StatusFilter,
      }
      this.$engine.firstOn().toolbox.getTestCaseTB(
      //this.$engine.firstOn().toolbox.getAccountTB(
        filterConditions
      ).then(resp => {
        this.RequestList = []
        if (resp.data.TestCase) {
          let requests = []
          if(resp.data.TestCase.List){
            let result = []
            if(!Array.isArray(resp.data.TestCase.List))
              result.push(resp.data.TestCase.List)
            else {
              result = resp.data.TestCase.List
            }
            if (result.length > 0){
              result.forEach( test =>{
                let aux = {}
                aux.id = test["~Unknown_1"]
                if(aux.id !== "$NotFound") {
                  aux.case_summary = test["~Unknown_2"]
                  aux.description_case = test["~Unknown_3"]
                  aux.case_type = test["~Unknown_4"]
                  aux.case_type_detailed = test["~Unknown_5"]
                  aux.tested_field = test["~Unknown_6"]
                  aux.criticality = test["~Unknown_7"]
                  aux.status = test["~Unknown_8"]
                  const foundElement = requests.find(item => item.id === aux.id);
                  if (foundElement) {
                    if (aux.id_dataset.length > 0)
                      foundElement.ids_dataset.push(aux.id_dataset)
                  } else {
                    let newTestCase = {
                      id: aux.id,
                      case_summary: aux.case_summary,
                      description_case: aux.description_case,
                      case_type: aux.case_type,
                      case_type_detailed: aux.case_type_detailed,
                      tested_field: aux.tested_field,
                      criticality: aux.criticality,
                      status: aux.status,
                      ids_dataset: [],
                      ids_valid: []
                    }
                    requests.push(newTestCase)
                  }
                }
              })
            }
          }
          if(resp.data.TestCase.DatasetCount){
            let result = []
            if(!Array.isArray(resp.data.TestCase.DatasetCount))
              result.push(resp.data.TestCase.DatasetCount)
            else {
              result = resp.data.TestCase.DatasetCount
            }
            if (result.length > 0) {
              result.forEach(test => {
                let cur = {}
                cur.idTestCase = test["~Unknown_1"]
                cur.idDataset = test["~Unknown_2"]
                const foundElement = requests.find(item => item.id === cur.idTestCase);
                if (foundElement) {
                  if (cur.idDataset.length > 0)
                    foundElement.ids_dataset.push(cur.idDataset)
                }
              })
            }
          }
          if(resp.data.TestCaseValid){
            let testCaseValid = []
            if(Array.isArray(resp.data.TestCaseValid))
              testCaseValid = resp.data.TestCaseValid
            else
              testCaseValid.push(resp.data.TestCaseValid)
            testCaseValid.forEach(valid_dataset => {
              let aux = {}
              aux.idTC = valid_dataset["~Unknown_1"]
              aux.idDS = valid_dataset["~Unknown_2"]
              aux.idStatus = valid_dataset["~Unknown_3"]
              aux.lastExec = valid_dataset["~Unknown_4"]
              const foundElement = requests.find(item => item.id === aux.idTC);
              if(foundElement) {
                foundElement.ids_valid.push(aux.idDS)
              }
            })
          }

          that.paginationObject.nbResultsTotal = resp.data.TestCaseCount
          that.paginationObject.nbResults = requests.length
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    setSelection(value){
      this.selectionMode = value
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/requestTBDetails/' + id})
    },
    reOrderBy (column) {
      this.AccountTBList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.firstOn().accountTB.getAccountTB(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
        that.paginationObject.nbResults = resp.data.tracks.length
        requests = resp.data.accounts
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.RequestList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeRequestTBDetails (items) {
      console.log("details")
      console.log(items)
      console.log("details")
      this.activateDetail(items.id)
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },

    trigOnImportCSV(){
      console.log("start importCSV")
      this.$refs.fileInput.click();
    },
    onImportCSV(event) {
      console.log("import todo")
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader()
        let validCSV = true
        reader.onload = (e) => {
          const csvContent = e.target.result
          validCSV = validCSV && this.isCSV(file) &&  this.isCSVContent(csvContent)
          if(validCSV)
            this.parseCSV(csvContent)
          else{
            this.okMessageBox(this.$t('toolbox.import_error_format'))
          }
        };
        reader.readAsText(file);
        this.$refs.fileInput.value = ""
      }
    },
    isCSV (file) {
      const validMimeTypes = ['text/csv', 'application/vnd.ms-excel']
      const extension = file.name.split('.').pop().toLowerCase()
      return validMimeTypes.includes(file.type) && extension === 'csv'
    },
    isCSVContent (content) {
      const lines = content.trim().split('\n')

      const delimiter = content.includes(';') ? ';' : ','
      const firstLineColumns = lines[0].split(delimiter).length

      return lines.every(line => line.split(delimiter).length === firstLineColumns)
    },
    parseCSV(csvContent) {
      const lines = csvContent.trim().split('\r\n')
      const delimiter = csvContent.includes(';') ? ';' : ','
      //const headers = lines.shift().split(delimiter);
      let that = this
      let request = {}
      console.log("check_header")
      const headers = lines[0].split(delimiter);
      const unknown_header = []
      headers.forEach(header => {
        if(!this.validHeader(header))
          unknown_header.push(header)
      })
      if(unknown_header.length > 0) {
        this.okMessageBox(this.$t('toolbox.import_error_unknown_header'))
        return
      }
      request.delimiter = delimiter
      request.content = []
      lines.forEach(lineContent => {
        const content = lineContent.split(delimiter)
        if(content !== undefined && content.length > 0)
          request.content.push(lineContent)
      })

      if(request.content.length === 1) {
        this.okMessageBox(this.$t('toolbox.import_empty_csv'))
        return
      }

      that.$engine.firstOn().toolbox.ImportTestCase(
          request
      ).then(resp => {
        if(resp.data.error)
          this.okMessageBox(this.$t('toolbox.import_content_error'))
        else
          this.onRefresh()
      }).catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    validHeader(header){
      switch (header){
        case 'ID_TEST_CASE' :
        case 'DESCRIPTION' :
        case 'IBAN' :
        case 'NAME' :
        case 'X_REQUEST_ID' :
        case 'X_RESPONSE_TIMESTAMP' :
        case 'CONTENT_TYPE' :
        case 'NAME_MATCH' :
        case 'ID_MATCH' :
        case 'MATCHED_NAME' :
        case 'ERROR_TYPE' :
        case 'ERROR_CODE' :
        case 'ERROR_STATUS' :
        case 'ERROR_DETAIL' :
        case 'ERROR_INSTANCE' :
        case 'SIREN' :
        case 'SIRET' :
        case 'TVAINTRACOMM' :
        case 'EUID' :
        case 'LEI' :
        case 'BIC' :
        case 'IDENTIFIER' :
        case 'SCHEME_NAME_CODE' :
        case 'SCHEME_NAME_PROPRIETARY' :
        case 'RESPONDING_BICFI' :
        case 'REQUESTING_BICFI' :
        case 'USTRD_INFO' :
        case 'IDENTIFICATION' :
        case 'HTTP_CODE' :
        case 'HTTP_MESSAGE' :
        case 'ERROR_TITLE' :
          return true
        default :
          return false
      }
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
